// extracted by mini-css-extract-plugin
module.exports = {"link":"CustomLink-module--link--3z_iF","directions":"CustomLink-module--directions--2TroI","arrow":"CustomLink-module--arrow--1CQ-i"};